import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { hideMessage } from '../../actions/FlashMessageActions';

import { console_log, parseQueryString } from "../../utils/helper";

class FlashMessage extends Component {
    constructor(props) {
        super(props);
        this.setTimeout = null;
        this.element = null;
    }

    componentDidMount() {
        this.element = document.querySelector('.flash-message');
        if (this.props.flashmessage.isShowing) {
            this.setTimeout = setTimeout(() => this.props.hideMessage(), 2000);
        }
    }

    componentDidUpdate() {
        this.element.classList.remove("notification-positive");
        this.element.classList.remove("notification-negative");
        if (this.props.flashmessage.isShowing) {
            if (this.setTimeout != null) {
                clearTimeout(this.setTimeout);
            }
            if (this.props.flashmessage.type) {
                this.element.classList.add("notification-positive");
            } else {
                this.element.classList.add("notification-negative");
            }
            this.setTimeout = setTimeout(() => this.props.hideMessage(), 2000);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.path != this.props.path) {
            this.props.hideMessage();
        }
    }

    componentWillUnmount() {
        this.props.hideMessage();
        clearTimeout(this.setTimeout);
    }
    
    render() {
        return (
            <div className={"flash-message"}>
                <a href="/#/">{this.props.flashmessage.message}</a>
            </div>
        )   
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        hideMessage
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(FlashMessage);


// WEBPACK FOOTER //
// ./src/components/FlashMessage/FlashMessage.js